import React, { Component } from 'react';
import * as ReactDOM from 'react-dom';


export const txtnullchk = (ctrl: any)=>{

let isctrlnull = true;
	
        if(ctrl.value.length > 0)
		isctrlnull = false;
  return isctrlnull;
	

};
export const isvaluenull = (ctrl: any)=>{

let isctrlnull = true;
	
        if(ctrl.length > 0)
		isctrlnull = false;
  return isctrlnull;
	

};
export const isequal = (str1: any,str2: any)=>{

let isctrlnull = true;
	
        if(str1 != str2 )
		isctrlnull = false;
  return isctrlnull;
	

};
export const isvldunm = (str1: any)=>{
let isctrlnull = false;
let regex = /^[a-zA-Z0-9]+$/;

if (regex.test(str1)) {
   isctrlnull = true;
} else {
   isctrlnull = false;

} 
 return isctrlnull;
	

};

export const isvalidatemail = (mailid: any)=>{

let isctrlnull = true;
let regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

if (regex.test(mailid)) {
   isctrlnull = true;
} else {
   isctrlnull = false;

} 
 return isctrlnull;
	

};
export const isvalidatedob = (dob: any)=>{

let isctrlnull = true;
let f2l = dob.substring(0,2);

if(f2l !='19' && f2l !='20'){ return false; }
let regex = /^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/
//let regex = ^(19|20)\d\d[-/.](0[1-9]|1[012])[-/.](0[1-9]|[12][0-9]|3[01])$;

if (dob.match(regex)) {
   isctrlnull = true;
} else {
   isctrlnull = false;

} 
 return isctrlnull;
	

};

export const isvalidmob = (mob: any)=>{

let isvld = true;
let regex = /^\d{10}$/;

//let regex = ^[0-9]{10}$;

if (mob.match(regex)) {
   isvld = true;
} else {
   isvld = false;

} 
 return isvld;

};
export const isvalidpin = (pin: any)=>{
let val = "";
let isvld = true;
let regex = /^\d{4}$/;
//let regex = ^[0-9]{10}$;
if (pin.match(regex)) {
val = pin.substring(0,1);
if(parseInt(val) > 0)
   isvld = true;
} else {
   isvld = false;
}
 return isvld;

};

export const isnumber = (num: any)=>{
   let isvld = true;
	if(!/[0-9]/.test(num)) isvld = false;
   return isvld;
}
export const isdecimal = (num: any)=>{
   let isvld = true;
	if(!/^-?\d*\.?\d*$/.test(num)) isvld = false;
   return isvld;
}
export const isvaliduser = ()=>{
   let isvld = true;
    const idvalue = localStorage.getItem("id");
    if(idvalue){
      const iddata = idvalue.toString();
      if(iddata == "0" || iddata=="NA") isvld = false;	
       	
    }
    else isvld = false;
		
   return isvld;
}
